module.exports = __webpack_public_path__ + "img/img4.d5fc2f2d.png";